import api from '@/api'

export default {
  cancelNewMake({ commit }) {
    commit('CANCEL_NEWMAKE')
  },
  setMakeActivation({ commit }, data) {
    commit('SET_MAKEACTIVATION', data)
  },
  addMake({ commit, state }, data) {
    commit('ADD_MAKE', data)
  },
  setMake({ commit, state }, data) {
    commit('SET_MAKE', data)
  },
  async getMakes({ commit, state }) {
    state.makes = []
    return new Promise((resolve, reject) => {
      api.getMakes(true)
        .then(response => {
          commit('SET_MAKES', response.data)
          resolve(response)
        })
    })
  },
  async saveMakes({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.saveMakes(data, { headers: { 'content-type': 'application/json' } })
        .then(response => {
          resolve(response)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/make/actions.js